<template>
  <v-container fluid class="pricelist-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/pricelist/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="pricelists-table"
              show-select
              single-select
              item-key="_id"
              sort-by="pricelistname"
              :footer-props="footer"
              :headers="headers"
              :items="pricelists"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Price List?
                    </v-card-title>

                    <v-card-text>
                      {{ deletePriceList.pricelistname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletePriceList)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.pricelistname="{ item }">
                <a class="primaryConst--text">{{ item.pricelistname }}</a>
              </template>
              <template v-slot:item.channelid="{ item }">
                <p class="two-line" v-if="item.channelid!=undefined">{{ saleschannels.length>0 ? saleschannels.find(channel=>channel._id == item.channelid)['channelname'] : ''  }}</p>
              </template>
              <template v-slot:item.priceliststatus="{ item }">
                <v-chip
                  :color="!item.priceliststatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.priceliststatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'pricelistList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deletePriceList: {},
      headers: [
        { text: 'Type', value: 'pricelisttype' },
        { text: 'Name', value: 'pricelistname' },
        { text: 'Channel', value: 'channelid' },

        { text: 'Status', value: 'priceliststatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      pricelistid: ['admin', 'pricelist'],
    }
  },

  computed: {
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('PriceList', ['pricelists', 'isReceiving', 'isDeleting', 'idToDelete', 'pricelistsMessage', 'isUpdating']),
  },
  async created () {
    await this.getPriceListsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
  },
  methods: {
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('PriceList', ["getPriceListsRequest","deletePriceListRequest","updatePriceListRequest","createPriceListRequest"]),
    editItem(item) {
      this.$router.push({ name: 'PricelistEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'PricelistPrint', params: item });
    },
    deleteItem(item) {
      this.deletePriceListRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletePriceList = {
        _id: item._id,
        pricelistname: item.pricelistname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
